import NextButton from "legacy/boater-reservation-flow/NextButton"
import { buildApiRoute } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class ContactInformation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emailValidationError: "",
      phoneValidationError: "",
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.setFullName = this.setFullName.bind(this)
    this.setEmail = this.setEmail.bind(this)
    this.setPhone = this.setPhone.bind(this)
    this.setContactInfo = this.setContactInfo.bind(this)
    this.checkEmail = this.checkEmail.bind(this)
    this.checkPhone = this.checkPhone.bind(this)
    this.abandonCartCapture = this.abandonCartCapture.bind(this)
    this.signIn = this.signIn.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Contact Information")
  }

  setFullName(event) {
    this.props.setGlobalState({ fullName: event.target.value })
  }

  setEmail(event) {
    this.props.setGlobalState({ email: event.target.value })
  }

  setPhone(event) {
    this.props.setGlobalState({ phone: event.target.value })
  }

  setContactInfo() {
    this.validator.showMessages()
    this.setState({ validInputs: this.validator.allValid() })
    Amplitude.trackEvent("reservation_flow:contact_info_continue_pressed", {
      marina_id: this.props.marina.mcomId,
      marina_name: this.props.marina.name,
      experience_name: "reservation_flow",
      embed_form: !!this.props.embedForm,
    })
    if (this.validator.allValid() === true) {
      this.setState({ processing: true })
      this.setState({ emailValidationError: "" })
      this.setState({ phoneValidationError: "" })
      this.checkEmail()
    }
  }

  checkEmail() {
    const postObject = { email: this.props.email }
    if (this.props.state.whiteLabel) {
      postObject.iu = true
    }
    $.post(buildApiRoute("validate/email"), postObject, (data) => {
      this.checkPhone()
    }).fail((data) => {
      if (data.status === 409) {
        this.signIn()
      } else {
        this.setState({
          emailValidationError: data.responseJSON.error,
          processing: false,
        })
      }
    })
  }

  checkPhone() {
    $.post(
      buildApiRoute("validate/phone"),
      { phone: this.props.phone },
      (data) => {
        this.props.routeTo("next")
        this.abandonCartCapture()
      }
    ).fail((data) => {
      this.setState({
        phoneValidationError: data.responseJSON.error,
        processing: false,
      })
    })
  }

  abandonCartCapture() {
    const params = {
      "contact[name]": this.props.fullName,
      "contact[email]": this.props.email,
      "contact[phone]": this.props.phone,
      check_in_date: this.props.state.arrival,
      check_out_date: this.props.state.departure,
      loa: this.props.state.loa,
      marina_slug: this.props.state.marinaSlug,
    }
    $.post(process.env.API_BASE_URL + "/api/1.0/boaters/capture", params)
  }

  signIn() {
    Amplitude.trackEvent("reservation_flow:already_a_user_log_in_pressed", {
      marina_id: this.props.marina.mcomId,
      marina_name: this.props.marina.name,
      experience_name: "reservation_flow",
      embed_form: !!this.props.embedForm,
    })
    this.props.routeTo("SignIn")
  }

  render() {
    return (
      <div id="contactInformation" className="contact-information">
        <div className="form-group">
          <label htmlFor="fullName">Full name</label>
          <div className="form-control-with-icon">
            <i className="fa-kit fa-user-male form-control-icon-left" />
            <input
              className="form-control"
              id="fullName"
              value={this.props.fullName}
              onChange={this.setFullName}
              autoFocus
            />
            {this.validator.message(
              "fullName",
              this.props.fullName,
              "required"
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <div className="form-control-with-icon">
            <i className="fa-kit fa-mail form-control-icon-left" />
            <input
              id="email"
              className="form-control"
              value={this.props.email}
              onChange={this.setEmail}
            />
            {this.validator.message(
              "email",
              this.props.email,
              "required|email"
            )}
            {this.validator.messageWhenPresent(this.state.emailValidationError)}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <div className="form-control-with-icon">
            <i className="fa-kit fa-phone-btm form-control-icon-left" />
            <input
              id="phone"
              className="form-control"
              value={this.props.phone}
              onChange={this.setPhone}
            />
            {this.validator.message(
              "phone",
              this.props.phone,
              "required|phone"
            )}
            {this.validator.messageWhenPresent(this.state.phoneValidationError)}
          </div>
        </div>
        {this.props.state.whiteLabel === false ? (
          <div className="text-muted text-center">
            We give this information to the marina so they can contact you
          </div>
        ) : null}
        <NextButton
          id="contactInfoContinueButton"
          btnClass="btn-primary"
          processing={this.state.processing}
          click={this.setContactInfo}
          icon=""
          text="Continue"
          processingText="Continue..."
        />
        {this.props.state.whiteLabel === false ? (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.signIn}
          >
            Already have a Dockwa account?
          </button>
        ) : null}
      </div>
    )
  }
}

ContactInformation.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  fullName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  state: PropTypes.object.isRequired,
  marina: PropTypes.object.isRequired,
  embedForm: PropTypes.bool,
}

export default ContactInformation
